import {
  AfterContentInit,
  ChangeDetectorRef,
  Component,
  ContentChild,
  EventEmitter,
  Input,
  OnInit,
  Output,
  QueryList,
  TemplateRef,
  ViewChild,
  ViewChildren,
} from '@angular/core';
import {
  NgControl,
  UntypedFormArray,
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { DomHandler } from 'primeng/dom';
import { ImageUploadComponent } from 'src/app/core/component/image-upload/image-upload.component';
import {
  arrayofData,
  fileCompData,
  fileInfo,
} from 'src/app/core/helper/core.data.interface';
import { AppConstant, RESPONSE_CODE } from 'src/app/helper/class/app-constant';
import {
  cleanForm,
  cloneData,
  convertDate,
  isArray,
  isEmptyObj,
  isExistsKey,
  mysqlDataTime,
  replacePlaceholder,
  transformTitle,
} from 'src/app/helper/class/utilityHelper';
import {
  ApiFilter,
  ResponseData,
  formBuilder,
  formBuilderData,
  formDynamicValidator,
  formEvent,
  formValidator,
} from 'src/app/helper/interface/response';
import { AuthService } from 'src/app/helper/service/auth.service';
import { MasterApiService } from 'src/app/modules/master/service/master-api.service';
import { AsyncApiService } from '../../service/async-api.service';

interface fileConfigController {
  [key: string]: fileCompData;
}

interface formConfig {
  //  type: eduType,
  title?: string;
  isView?: boolean;
  isRequest?: boolean;
}

@Component({
  selector: 'app-form-generator',
  templateUrl: './form-generator.component.html',
  styleUrls: ['./form-generator.component.scss'],
})
export class FormGeneratorComponent implements OnInit, AfterContentInit {
  @Input() public set formData(dat: any) {
    if (dat) {
      this.data = cloneData(dat);
    }
  }
  configData!: formConfig;
  @Input() public set config(s: formConfig) {
    if (!isEmptyObj(s) && s) {
      this.configData = s;
    }
  }
  @Input() dynamicValidator: formDynamicValidator[] = [];
  data: any = [];
  dataForm: UntypedFormGroup | any = {};
  @Input() submitted: boolean = true;
  loading: boolean = false;
  EDITOR_DATA: arrayofData = {};
  apiData: any = {};
  initialFormValue: any = {};
  dateFormat = AppConstant.DATE_FORMAT;
  FORM_SUPPORT_DATA: arrayofData | any = {};
  fileConfig: fileConfigController = {} as fileConfigController;
  DATA_LOADING: any = {};
  defaultKeyFilter = /^.*$/;
  loadForm: boolean = false;
  private isApplyingData: boolean = false; // flag to skip value resets during applyFormValue
  @Input() globalValidator = [];
  @Output() onChangeEvent: EventEmitter<any> = new EventEmitter();
  @Output() onBtnEvent: EventEmitter<any> = new EventEmitter();
  @Output() onLoad: EventEmitter<any> = new EventEmitter();
  @Output() onApiEvent: EventEmitter<{ colName: string; data: any }> =
    new EventEmitter();
  @ViewChildren('imageUploader') imageUploader:
    | QueryList<ImageUploadComponent>
    | undefined;
  @ViewChild('calender') calender: any;
  @ContentChild('formBody') public formBody!: TemplateRef<any>;
  @ViewChildren(NgControl) formControls!: QueryList<NgControl>;
  @ViewChildren('drop') drop!: any;
  isShowEditBtn: boolean = false;
  isShowDeleteBtn: boolean = false;
  constructor(
    private masterApi: MasterApiService,
    private ref: ChangeDetectorRef,
    private auth: AuthService,
    private asyncApi: AsyncApiService
  ) {}

  ngOnInit(): void {
    this.initForm();
  }
  toggleEditBtn(status = false) {
    this.isShowDeleteBtn = status;
    this.isShowEditBtn = status;
  }
  onClickBtn(btnName, formCtrl, index) {
    this.onBtnEvent.next({ event: btnName, control: formCtrl, index: index });
  }
  setFormData(data: formBuilderData | formBuilderData[]) {
    this.data = data;
    this.initForm();
  }

  ngAfterContentInit() {
    this.ref.detectChanges();
  }

  generateType(col: string): 'DATE' | 'text' | 'CURRENCY' {
    if (/(_at$|_date$|date$|_date)/i.test(col)) {
      return 'DATE';
    } else if (/(amount|rupees)/i.test(col)) {
      return 'CURRENCY';
    }
    return 'text'; // Default case if none of the conditions match
  }

  initForm() {
    this.loadForm = false;
    if (!this.data) {
      return;
    }
    this.FORM_SUPPORT_DATA = {};
    this.DATA_LOADING = {};
    const group: any = {};
    this.data.map((a: formBuilder | any, i) => {
      a.title =
        a.title_case == 'NONE'
          ? a.title || a.colName
          : transformTitle(a.title || a.colName);
      a.master_validator = a.validator || [];

      if (a.type == 'chips') {
        a.validator = a.validator?.filter(
          (c: formValidator) => c.name != 'pattern'
        );
      }
      const { v, asyn } = this.transformValidator(a.validator, a.title, i);
      group[a.colName] = new UntypedFormControl(a.defaultValue || '', v, asyn);
      a.type = a.type == undefined ? this.generateType(a.colName) : a.type;
      if (a.type == 'FILE') {
        const config = {
          ...{
            filePath: a?.fileConfig?.filePath || '',
            label: a.title,
            fileType: a?.fileConfig?.fileType || 'IMAGE',
          },
          ...(a?.fileConfig || {}),
        };
        this.fileConfig[a.colName] = config;
      } else if (
        a.type == 'select' ||
        a.type == 'dropdown' ||
        a.type == 'checkbox' ||
        a.type == 'radio' ||
        a.type == 'MULTISELECT' ||
        a.type == 'AUTOCOMPLETE' ||
        a.type == 'autocomplete'
      ) {
        (a.selectPrimaryKey = a.selectPrimaryKey || 'id'),
          (a.selectKeyName = a.selectKeyName || a?.selectKeyName || '');
        if (a.data?.length || a.apiTblName) {
          if (isArray(a.data)) {
            const d = a?.data?.map((b: any) => {
              return {
                ...b,
                [a.selectPrimaryKey]: b[a?.selectPrimaryKey]?.toString(),
              };
            });
            this.FORM_SUPPORT_DATA[a.colName] = d;
          }
        }
      } else if (a.type === 'formArray') {
        const arrayGroup = new UntypedFormArray([]);
        group[a.colName] = arrayGroup;
        // The a.formArrayConfig will contain formBuilderData[] of subfields
      }
      return a;
    });
    const g: any = {};
    // const global = this.data.filter(a => a.validator?.find(a.name == 'dateComparison'));
    // if (isArray(this.globalValidator)) {
    //   g.validators = []
    //   this.globalValidator.forEach((a: any) => {
    //     const c = a?.name || 'dateComparisonValidator';
    //     g.validator.push(dateComparisonValidator(a.colName, a.compareColName, a.type))
    //   });
    // }
    this.dataForm = new UntypedFormGroup(group, g);
    this.loadForm = true;
    this.apiCallInit();
    this.changeValidator();
    this.onLoad.emit(true);
  }

  protected createFormControl() {}

  reset() {
    const defaultValue: any = {};
    this.data.forEach((a: any) => {
      if (a.defaultValue != undefined) {
        defaultValue[a.colName] = a.defaultValue;
      }
    });
    this.dataForm.reset(defaultValue);
    this.imageUploader?.toArray().forEach((e) => {
      e.resetFileInput();
    });
    Object.keys(this.fileConfig).forEach((a: string) => {
      this.fileConfig[a].filePath = '';
    });
  }

  transformValidator(
    validator: formValidator[] = [],
    title = '',
    index: number = 0
  ) {
    const v: any = [],
      at: any = [],
      asyn: any = [];
    if (isArray(validator)) {
      validator.forEach(async (b: formValidator) => {
        if (b.name == 'dateComparison') {
          return;
        }
        const sv = cloneData(b);
        const arrayFunVal = ['pattern', 'minLength', 'maxLength', 'min', 'max'];
        const s = arrayFunVal.includes(b.name)
          ? Validators[b.name](this.ensureRegex(b.funValue))
          : Validators[b.name];
        sv.error =
          b.error ||
          (b.name == 'pattern'
            ? title + ' is not valid '
            : b.name == 'required'
            ? title + ' is required'
            : ' error occurred');
        if (!b.is_async) {
          v.push(s);
        } else {
          if (b.funName) {
            b.colName = b.colName || this.data[index].colName;
            asyn.push(this.asyncApi[b?.funName](b));
          }
        }
        at.push(sv);
      });
      this.data[index].validator = at;
    }
    return { v, asyn };
  }
  ensureRegex(input: string | RegExp): RegExp {
    if (input instanceof RegExp) {
      return input;
    } else {
      // Optional: Handle string like "/pattern/flags"
      const match = input.match(/^\/(.*)\/([gimsuy]*)$/);
      if (match) {
        return new RegExp(match[1], match[2]);
      }
      // Simple pattern without delimiters
      return new RegExp(input);
    }
  }

  skipAsync() {}
  checkOperation(val: any, compare: any, operation = '==') {
    val = [null, undefined, ''].includes(val) ? '' : val; // on staff transfer church issues
    let result = false;
    switch (operation) {
      case '!=':
        if (Array.isArray(compare)) {
          return (result = compare.some((item) => item != val));
        } else {
          result = val != compare;
        }
        break;
      case '>=':
        result = val >= compare;
        break;
      case '>':
        result = val > compare;
        break;
      case '<':
        result = val < compare;
        break;
      default:
        if (Array.isArray(compare)) {
          return (result = compare.some((item) => item == val));
        } else {
          result = val == compare;
        }
        break;
    }
    return result;
  }

  changeValidator(skipReset: boolean = false) {
    const matches: formDynamicValidator[] = [];
    const nonMatches: formDynamicValidator[] = [];

    this.dynamicValidator.forEach((a: formDynamicValidator) => {
      if (this.dataForm.controls[a.controlName]) {
        if (
          this.checkOperation(
            this.dataForm.value[a.controlName],
            a.value,
            a.operation || '=='
          )
        ) {
          matches.push(a);
        } else {
          nonMatches.push(a);
        }
      }
    });

    // Apply non-matches first to reset state, then matches to override
    // skipReset=true prevents value resets during initial data load (applyFormValue)
    nonMatches.forEach((a) => this.toggleValidation(a, false, skipReset));
    matches.forEach((a) => this.toggleValidation(a, true, skipReset));
  }

  private toggleValidation(a: any, status: boolean = false, skipReset: boolean = false) {
    const validatorCtr = cloneData(a);
    validatorCtr?.validatorControl?.forEach((b: any) => {
      const i = this.data.findIndex((a: formBuilder) => a.colName == b),
        da = this.data[i];
      if (typeof da != 'undefined') {
        da.validator = status
          ? [...(da?.master_validator || []), ...(validatorCtr.validator || [])]
          : da.master_validator || [];
        const { v, asyn } = this.transformValidator(da.validator, da.title, i);
        this.dataForm.controls[b].clearValidators();
        if (isArray(v)) {
          this.dataForm.controls[b]?.setValidators(v);
        }
        // Only reset values when NOT in data-loading mode and the condition does not match
        if (!status && !skipReset) {
          if (b != a.controlName) {
            this.dataForm.patchValue({ [b]: da?.defaultValue || '' });
          }
        }
        this.dataForm.controls[b]?.updateValueAndValidity();
      }
    });
    a?.hideControl?.forEach((e: any) => {
      this.toggleControl(e, status);
    });
    a?.showControl?.forEach((e: any) => {
      this.toggleControl(e, status);
    });
    a?.hideControlOnMatch?.forEach((e: any) => {
      this.toggleControl(e, !status);
    });
    this.toggleDisableByCtrl(a?.disableControl, status);
  }

  toggleControl(ctrlName: string, show: boolean = true) {
    if (isArray(this.data)) {
      this.data.map((a: formBuilder) => {
        if (a.colName == ctrlName) a.invisible = !show;
      });
    }
  }

  getFormValue(changesOnly = false) {
    cleanForm(this.dataForm);
    const formData: any = cloneData(this.dataForm.getRawValue());
    for (let a of this.data) {
      // this.data.forEach((a: formBuilder) => {
      const skipId = ['select', 'MULTISELECT', 'radio'];
      if (a.type && skipId.includes(a.type) && a.selectKeyName != 'name') {
        formData[a?.selectKeyName || ''] = this.FORM_SUPPORT_DATA[
          a?.colName
        ]?.find(
          (b: any) => b[a?.selectPrimaryKey || 'id'] == formData[a?.colName]
        )?.[a?.selectKeyName || ''];
        if (Array.isArray(formData[a?.colName])) {
          formData[a?.selectKeyName || ''] = this.FORM_SUPPORT_DATA[a?.colName]
            ?.filter((b: any) =>
              formData[a?.colName].includes(b[a?.selectPrimaryKey || ''])
            )
            ?.map((d: any) => d[a?.selectKeyName || ''])
            ?.toString();
        }
      } else if (a.type == 'DATE') {
        if (isArray(formData[a?.colName])) {
          formData[a.colName].map((de) => convertDate(de) || null);
          // formData[a?.colName][0] = convertDate(formData[a?.colName][0]) || null;
          // if (formData[a?.colName][1])
          //   formData[a?.colName][1] = convertDate(formData[a?.colName][1]) || null;
        } else
          formData[a?.colName] = formData[a?.colName]
            ? convertDate(formData[a?.colName])
            : null;
      } else if (a.type == 'DATETIME') {
        formData[a?.colName] = formData[a?.colName]
          ? mysqlDataTime(formData[a?.colName])
          : null;
      } else if (a.type == 'AUTOCOMPLETE') {
        if (!isEmptyObj(formData[a.colName])) {
          const va: any = formData[a.colName];
          a.autoSearch?.selectFieldKeys?.forEach((c) => {
            formData[c] = va[c];
          });
        }
        if (a.selectionMode == 'multiple') {
          if (!isArray(formData[a.colName])) {
            formData[a?.colName] = [];
          }
        } else if (formData[a.colName] && !isEmptyObj(formData[a.colName])) {
          const d = formData[a?.colName]?.[a.selectPrimaryKey || 'id'] || '';
          formData[a?.colName] = d;
        }
      } else if (Array.isArray(formData[a?.colName])) {
        //not for autocomplete
        formData[a?.colName] = formData[a?.colName].toString();
      } else if (a.type == 'checkbox') {
        // Convert truthy value → "Yes", falsy → "No" for backend storage
        formData[a?.colName] = +formData[a?.colName];
      }
      if (changesOnly && a.colName) {
        let oldValue = this.initialFormValue[a.colName];
        if (a.type == 'DATETIME') {
          oldValue = oldValue ? mysqlDataTime(oldValue) : oldValue;
        } else if (a.type == 'DATE') {
          oldValue = oldValue ? convertDate(oldValue) : oldValue;
        }
        if (formData[a.colName] == oldValue) {
          //skip the loop
          if (a.selectKeyName) {
            delete formData[a.selectKeyName];
          }
          delete formData[a.colName];
          continue;
        }
      }
    }
    Object.keys(this.fileConfig).forEach((a: string) => {
      formData[a + '_path'] = this.fileConfig[a].filePath;
    });
    return formData;
  }

  onSelectAutocomplete(ev: any, f: formBuilderData) {
    this.onChangeEvent.emit({
      controlName: f.colName,
      value: ev?.target?.value || '',
      event: ev,
    });
  }
  filterItems(ev: any, f: formBuilderData) {
    if (!ev.query) {
      return;
    }
    const tblName: string = f.apiFunName || '';
    let Api;
    if (f.apiTblName) {
      //@ts-ignore
      Api = this.masterApi[tblName](f.apiTblName, ev.query);
    } else {
      //@ts-ignore
      Api = this.masterApi[tblName](ev.query, f.autoSearch?.whereFiled || []);
    }
    this.apiCall(Api, f.colName, true);
  }

  apiCallInit() {
    const skipLevel: any = [];
    this.data.map((a: formBuilderData) => {
      if (a.type == 'AUTOCOMPLETE') {
        skipLevel.push(a.colName);
      }
      if (
        (a.apiTblName || a.apiFunName) &&
        !a.data?.length &&
        !skipLevel.includes(a.colName)
      ) {
        //only apiTable and apiFunName  allow
        this.getFullData(
          a.apiTblName || '',
          [],
          a.colName,
          false,
          '',
          a.apiFunName || ''
        );
        //to check event on dynamic dropdown and auto assign
        if (a?.event?.valueAssign) {
          skipLevel.push(a.event.valueAssign);
          if (
            this.dataForm.value[a.colName] &&
            (a?.event?.apiTblName || a?.event?.apiFunName)
          ) {
            this.getFullData(
              a.event.apiTblName || '',
              [],
              a.event.valueAssign,
              false,
              '',
              a.event.apiFunName || ''
            );
          }
        }
      }
    });
  }

  onChange(ctrlName: string, e: any) {
    this.onChangeEvent.emit({
      controlName: ctrlName,
      value: e?.target?.value || e?.value || '',
      event: e,
    });
    this.onSelectCalender(ctrlName);
    this.changeValidator();
  }

  MULTI_SELECT_SELECT_ALL = {};
  onSelectAllChange(f: any, event) {
    this.MULTI_SELECT_SELECT_ALL[f.colName] = event.checked;
    const va = [];
    if (event.checked) {
      this.FORM_SUPPORT_DATA[f.colName].forEach((dataValue: any) => {
        const pKey = f.selectPrimaryKey || 'id';
        //@ts-ignore
        va.push(dataValue[pKey]);
      });
    }
    this.setValue(f.colName, va);
    if (f.event?.name == 'change' && f.event?.isCallback) {
      this.onChange(f.colName, event);
    } else if (f.event?.name == 'change') {
      if (va.length) {
        this.getFullData(
          f.event.apiTblName,
          [],
          f.event.valueAssign,
          true,
          f.colName,
          f.event?.apiFunName
        );
      } else {
        this.setValue(f.event.valueAssign, '');
        this.FORM_SUPPORT_DATA[f.event.valueAssign] = [];
      }
    }
  }

  onInput(ctrlName: string, e: formEvent) {
    if (e.isSelfAssign) {
      if (e.apiFunName)
        this.dataForm.controls[ctrlName].setValue(
          this.dataForm.controls[ctrlName].value[e.apiFunName]()
        );
    }
  }

  setData(data: any) {
    if (!isEmptyObj(data)) {
      // Convert only number primitives at top level to strings
      Object.keys(data).forEach((key) => {
        const val = data[key];
        if (typeof val === 'number') {
          data[key] = val.toString();
        }
      });
      this.apiData = data;
      this.initialFormValue = cloneData(data);
      if (!this.configData?.isView) {
        setTimeout(() => {
          this.applyFormValue();
        }, 600); // delay in ms
      }
    }
  }

  setDefaultData(data: any) {
    if (!isEmptyObj(data)) {
      this.data.map((a: formBuilderData) => {
        if (data[a.colName]) {
          a.defaultValue = data[a.colName];
        }
        return a;
      });
    }
  }

  setValue(ctrlName: string, value: any, triggerEvent: boolean = false) {
    this.dataForm?.patchValue({ [ctrlName]: value });
    this.changeValidator();
    if (triggerEvent) {
      const f = this.data.find((a) => a.colName == ctrlName);
      if (f?.event?.name == 'change') {
        //const cond: any = [value];
        this.getFullData(
          f?.event?.apiTblName,
          [],
          f?.event?.valueAssign,
          true,
          f?.colName,
          f?.event?.apiFunName
        );
      } else {
        this.onChange(ctrlName, { targrt: { value: value } });
      }
    }
  }

  patchValue(d: any) {
    if (!isEmptyObj(d)) {
      this.dataForm?.patchValue(d);
      this.changeValidator();
    }
  }

  get formValue() {
    return this.dataForm.value;
  }

  getformValueByControl(colName) {
    return this.getFormValue()?.[colName] || '';
  }

  apiPayload() {
    let payload: any = this.formValue;
    Object.keys(this.fileConfig).forEach((a: string) => {
      payload[a + '_path'] = this.fileConfig[a].filePath;
    });
    return payload;
  }

  onAddChips(e: any, ctrlName: string) {
    if (e.value) {
      let pattern: any = '';
      const col = this.data.find((a) => a.colName == ctrlName),
        d = col?.validator?.filter((c: any) => c.name == 'pattern');
      if (d && d[0]) {
        pattern = d[0]['funValue'];
      }
      if (pattern && !pattern?.test(e.value)) {
        const currentValues = [...(this.dataForm.get(ctrlName)?.value || [])];
        currentValues.pop();
        this.dataForm.get(ctrlName)?.setValue(currentValues);
      }
    }
  }

  didUpload(fileInfo: fileInfo, ctrlName: string) {
    this.fileConfig[ctrlName].filePath = fileInfo.filePath;
    const fileName = this.apiData[ctrlName]
      ? `${fileInfo.fileName}${AppConstant.DEFAULT_OLD_IMAGE_APPEND}${this.apiData[ctrlName]}`
      : fileInfo.fileName;
    this.dataForm.patchValue({ [ctrlName]: fileName });
    this.onChange(ctrlName, { target: { value: fileName } });
  }

  getFullData(
    tblName: any,
    cond = [],
    pValue: string,
    isEvent = false,
    colName: any = '',
    apiFun: string = '',
    eventValue: any = {}
  ) {
    console.log('event vale', eventValue,cond);
    if (isEvent) {
      const isNum = typeof this.dataForm.value[colName] == 'number',
        ifc = isNum
          ? this.dataForm.value[colName] > 0
          : this.dataForm.value[colName];
      if (ifc) {
        //@ts-ignore
        cond.push(this.dataForm.value[colName]);
      }
      const d: formBuilder = this.data.find(
        (a: formBuilder) => a.colName == colName
      );
      if (d.event?.valueMap) {
        if (isArray(d.event.valueMap)) {
          const dataSupport = this.FORM_SUPPORT_DATA[colName].find(
            (a) => a.id == this.dataForm.value[colName]
          );
          if (dataSupport) {
            d.event.valueMap.forEach((e) => {
              if (e.controlName) {
                this.setValue(e.controlName, dataSupport[e.supportKeyName]);
              }
            });
          }
        }
      }
      // The previously selected value of the dependent field (pValue) is no longer
      // valid once its parent (colName) changes, e.g. State/District under a changed
      // Country. Clearing it here (opt-in via event.resetOnChange) cascades transitively
      // through setValue's own triggerEvent path, since pValue's field may itself have
      // an event.valueAssign of its own.
      if (d.event?.resetOnChange && pValue && this.dataForm.value[pValue]) {
        this.setValue(pValue, '', true);
      }
    }
    if (tblName || apiFun) {
      this.DATA_LOADING[pValue] = true;
      let api: any;
      if (apiFun) {
        const d: formBuilder = this.data.find(
          (a: formBuilderData) => a.colName == colName
        );
        const params_logic = d?.event?.addParams || [],
          params: any = [];
        if (isArray(params_logic) && d?.event) {
          params_logic?.forEach((c: any) => {
            if (c.colName) {
              const parmSupportData = this.getSupportData(d.colName);
              const paramSelectedData = parmSupportData.find(a => a[d.selectPrimaryKey ?? 'id'] == eventValue.value);
              params.push(this.dataForm?.value[c.colName] ?? paramSelectedData[c.colName]);
            } else if (c.constantValue) {
              params.push(c.constantValue);
            }
            // have api parameter
          });
          if (d?.apiParameter) {
            if (d.apiParameter?.colName) {
              d.apiParameter.colName.forEach((e: any) => {
                if (e?.name) {
                  if (this.dataForm.value[e.name]) {
                    params.push(this.dataForm.value[e.name]);
                  }
                } else if (e?.value) {
                  params.push(...e.value);
                }
              });
            }
          }
        }
        if (isArray(params)) {
          const merge = [
            ...cond,
            ...params,
          ];
         api = this.masterApi[apiFun].apply(this.masterApi, merge);
        } else {
          api = this.masterApi[apiFun](cond);
        }
      } else {
        api = this.masterApi.getFullData(tblName, cond, false);
      }
      if (isEvent) {
        this.onChange(colName, {
          target: { value: this.dataForm.value[colName] },
        });
      }
      this.apiCall(api, pValue, isEvent);
    }
  }

  apiCall(api: any, pValue: string, isEvent: boolean = false) {
    api
      .then((res: ResponseData | any) => {
        if (res.statusCode == RESPONSE_CODE.SUCCESS) {
          let colData: formBuilder = this.data.find(
              (a: formBuilder) => a.colName == pValue
            ),
            data = colData.appendData || [],
            resultD = res.result;
          if (!isArray(resultD)) {
            data = [];
          }
          const aF: ApiFilter = colData.apiFilter || {};
          if (!isEmptyObj(aF)) {
            let v = aF.value || '',
              keyName = aF.keyName || colData.selectKeyName || '';
            //filter is on
            if (aF.moduleName) {
              keyName = aF.keyName || 'id';
              const rol = aF.roleKey || colData.apiTblName || colData.colName;
              v = this.auth
                .getPermittedData(
                  [aF.moduleName],
                  //@ts-ignore
                  [aF.actionName],
                  [rol]
                )
                ?.find((a) => a.colName == rol)?.value;
              //v = isArray(v) && v?.length == 1 ? v[0].split(',') : v;
              console.log('filter value', v, keyName, rol);
            }
            if (v?.length) {
              //replace place holder if have
              v =
                typeof v == 'string'
                  ? replacePlaceholder(v, this.dataForm.value)
                  : v;
              resultD = resultD.filter((b: any) =>
                this.checkOperation(b[keyName], v, aF?.operation || '==')
              );
            }
          }
          this.FORM_SUPPORT_DATA[pValue] = [...data, ...resultD];
          this.FORM_SUPPORT_DATA[pValue].map((a: any) => {
            a[colData?.selectPrimaryKey || 'id'].toString();
            return a;
          });
          this.mapFormValue(this.dataForm.value, 'API');
          this.onApiEvent.emit({
            colName: pValue,
            data: this.FORM_SUPPORT_DATA[pValue],
          });
        } else {
          this.FORM_SUPPORT_DATA[pValue] = [];
        }
      })
      .finally(() => (this.DATA_LOADING[pValue] = false));
  }

  applyFormValue() {
    this.isApplyingData = true; // prevent value resets during data load
    const aValue: any = {};
    this.data.map((a: formBuilderData) => {
      let val = this.apiData[a.colName];
      if (a.type == 'DATE' || a.type == 'DATETIME') {
        val = val?.date || val;
        const dt =
            val instanceof Date
              ? [val]
              : isArray(val)
              ? val
              : val
              ? val.split(',')
              : [null],
          dtN: any = [];
        dt.map((e) => {
          e = !['0000-00-00', null].includes(e) ? new Date(e) : '';
          dtN.push(e);
        });
        val = dtN;
        if (!dtN[1]) {
          val = dtN[0];
        }
      } else if (a.type == 'FILE') {
        const col: string = a.colName + '_path';
        if (this.fileConfig[a.colName]) {
          this.fileConfig[a.colName] = {
            filePath: this.apiData[col],
            fileType: 'IMAGE',
          };
        }
      } else if (a.type == 'chips') {
        val = Array.isArray(val) ? val : val == null ? [] : val.split(',');
      } else if (a.type == 'checkbox') {
         val = +val;
        // // Normalize API value: accept "Yes"/1/true → 1; "No"/0/false/null → 0
        // if (typeof val === 'string') {
        //   val = val.toLowerCase() === 'yes' ? 1 : 0;
        // } else {
        //   val = +val;
        // }
      } else if (a.type == 'editor') {
        this.EDITOR_DATA[a.colName] = val;
      } else if (a.type == 'AUTOCOMPLETE') {
        if (a.selectKeyName && a.selectionMode != 'multiple') {
          val = {
            [a.selectKeyName || 'id']: this.apiData[a.selectKeyName || 'id'],
            [a.selectPrimaryKey || 'id']: this.apiData[a.colName] || '',
          };
        }
      }
      aValue[a.colName] = val;
    });
    this.removeWhiteSpace();
    this.mapFormValue(aValue);
    this.apiCallDependent();
    this.isApplyingData = false; // allow value resets again after data load completes
  }
  onDescriptionChange(e: any, controlName: string) {
    this.dataForm.patchValue({ [controlName]: e });
  }

  mapFormValue(g: any, type: 'API' | 'DEFAULT' = 'DEFAULT') {
    const data: any = {};
    let colName = '';
    Object.keys(this.dataForm.controls).forEach((a: any) => {
      if (isExistsKey(g, [a])) {
        data[a] = g[a] || '';
        colName = a;
      }
    });

    if (type == 'API' && colName) {
      let col: any = this.data.filter(
        (a: formBuilderData) => a.type == 'AUTOCOMPLETE'
      );
      col.forEach((b: any) => {
        if (isExistsKey(data, b.colName)) {
          delete data[b.colName];
        }
      });
    }

    if (!isEmptyObj(data)) {
      this.dataForm.patchValue(data);
    }
    // Pass skipReset=true when we are loading API data so that value resets are skipped
    this.changeValidator(this.isApplyingData);
  }

  apiCallDependent() {
    this.data.map((a: formBuilderData) => {
      if (a.event && this.apiData) {
        if ((a.apiTblName || a.event) && a.event.valueAssign) {
          const cond: any = [this.apiData[a.colName]];
          if (a.event.apiFunName) {
            if (!cond.includes(null)) {
              this.getFullData(
                a.event.apiTblName || '',
                cond,
                a.event.valueAssign,
                false,
                a.colName,
                a.event?.apiFunName
              );
            }
          } else {
            this.getFullData(a.event.apiTblName, cond, a.event.valueAssign);
          }
        }
      }
    });
  }

  isValid() {
    return this.dataForm['status'] == 'DISABLED' || this.dataForm.valid;
  }

  setSubmitted(s: boolean) {
    this.submitted = s;
  }
  setSupportData(colName, data) {
    this.FORM_SUPPORT_DATA[colName] = data;
  }

  getSupportData(colName): Array<any> {
    return this.FORM_SUPPORT_DATA[colName] || [];
  }
  getSelectedSupportData(colName): Array<any> {
    const d = this.FORM_SUPPORT_DATA[colName] || [];
    return d.find((a) => a.id == this.dataForm.value[colName]);
  }

  formStatusError(navigate = true): { status: Boolean; error?: string } {
    const controls = this.formControls.toArray();
    console.log(controls);
    let i = -1;
    for (let field of controls) {
      i++;
      if (field.invalid) {
        console.log(field?.valueAccessor);
        const el =
          (field.valueAccessor as any)?.el ||
          (field.valueAccessor as any)?._elementRef?.nativeElement;
        if (el) {
          const d = el.nativeElement
            .closest('.form-group')
            .querySelector('span:last-child');
          console.log('error', d.innerHTML);
          // el.focus();
          DomHandler.findSingle(
            el.nativeElement,
            '.p-dropdown-label.p-inputtext'
          ).focus();
          return { status: false, error: d.innerHTML };
          // el.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'end', inline: 'start' });
          //DomHandler.findSingle(el.el.nativeElement,'.p-inputwrapper').focus()// el.;
        }
        break;
      }
    }
    return { status: true };
  }

  toggleDisableByCtrl(ctrlName: string | string[], toogle: boolean = false) {
    const s = Array.isArray(ctrlName) ? ctrlName : [ctrlName];
    s.forEach((a) => {
      if (this.dataForm.controls[a]) {
        const fun = toogle ? 'disable' : 'enable';
        this.dataForm.controls[a]?.[fun]();
      }
    });
  }
  toggleHideByCtrl(ctrlName: string | string[], toogle: boolean = false) {
    const s = Array.isArray(ctrlName) ? ctrlName : [ctrlName];
    s.forEach((a) => {
      const s = this.data.map((b: formBuilder) => {
        if (b.colName == a) {
          b.hidden = toogle;
        }
        return b;
      });
      if (this.dataForm.controls[a]) {
        const fun = toogle ? 'disable' : 'enable';
        this.dataForm.controls[a]?.[fun]();
      }
    });
  }

  removeWhiteSpace() {
    cleanForm(this.dataForm);
  }
  onSelectCalender(ctrlName: any) {
    const i = this.data.findIndex((a: formBuilder) => a.colName == ctrlName);
    if (this.data[i].selectionMode == 'range' && this.data[i].type == 'DATE') {
      const val = this.dataForm.value[ctrlName];
      if (Array.isArray(val) && val[1]) {
        this.calender.overlayVisible = false;
      }
    }
  }

  reAssignData(data: any, index: number) {
    if (!Array.isArray(data)) {
      this.data[index] = data;
    } else {
      this.data = data;
    }
  }

  isFormChange() {
    const src = JSON.stringify(this.initialFormValue);
    const to = JSON.stringify(this.dataForm.value);
    return !(src === to);
  }
}
